import useApi from "../../use/useApi";
import {useSelector} from "react-redux";
import isNull from "../../mixin/isNull";
import QuotationItem from "../../entity/insurance/QuotationItem";

const SERVICE = "service-insurance";
const ENTITY = "quotation_items";

export default function () {
    const {findOneBy, create, update, remove} = useApi();
    const state = useSelector;
    const newInstance = data => new QuotationItem(data);

    return {
        findOneById(id) {
            return {
                select() {
                    const result = state(state => state.api?.insurance?.[ENTITY]?.[id]);

                    if (isNull(result)) return null;

                    return result;
                },
                exec() {
                    return findOneBy(SERVICE, ENTITY, "id", id, newInstance, "application");
                }
            }
        },
        findAllByIds(ids) {
            return {
                select() {
                    const all = state(state => state.api?.insurance?.[ENTITY]);

                    if (isNull(ids) || isNull(all)) return [];

                    return ids.map(id => all[id]).filter(item => !isNull(item));
                },
                exec() {
                    if (isNull(ids)) return;

                    ids.forEach(id => findOneBy(SERVICE, ENTITY, "id", id, newInstance, "application", true));
                }
            }
        },
        async create(payload) {
            return create(SERVICE, ENTITY, payload, newInstance, "application");
        },
        async update(id, property, payload) {
            return update(SERVICE, ENTITY, id, property, payload, newInstance, "application");
        },
        async remove(id) {
            return remove(SERVICE, ENTITY, id, "application");
        }
    }
}
